import "./style.css";
import { readFreebuildToolRoute } from "./runtime/toolRoutes";

const root = document.querySelector<HTMLDivElement>("#app");

if (!root) {
  throw new Error("TasteeWheat runtime root element was not found.");
}

const appRoot = root;
const route = readFreebuildToolRoute(window.location);

async function start(): Promise<void> {
  if (route === "assets") {
    const { AssetExplorerRuntime } = await import("./runtime/toolPages");
    new AssetExplorerRuntime(appRoot).start();
    return;
  }

  if (route === "editor") {
    const { WorldEditorRuntime } = await import("./runtime/toolPages");
    new WorldEditorRuntime(appRoot).start();
    return;
  }

  if (route === "outfit") {
    const { CharacterOutfitBuilderRuntime } = await import("./runtime/characterOutfitBuilder");
    new CharacterOutfitBuilderRuntime(appRoot).start();
    return;
  }

  const { FreebuildRuntime } = await import("./runtime/freebuildRuntime");
  new FreebuildRuntime(appRoot).start();
}

void start();
